import {
  sendQitafOtp
} from "./chunk-PCEF24UO.mjs";

// src/hooks/wbk/qitaf/sendOtp.ts
import { useMutation } from "@tanstack/react-query";
var useSendQitafOtp = () => {
  return useMutation({
    mutationFn: sendQitafOtp
  });
};

export {
  useSendQitafOtp
};
//# sourceMappingURL=chunk-X5UKCPAS.mjs.map